<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Row, Col, SelectCard } from '@Shelly/shelly-design-system';
	import { capFirstChar } from '../../../../../../../../helpers/utilities';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let sceneData: any;

	const triggerTypes = [
		{
			title: capFirstChar($format('condition_type_one', { default: 'Once' })),
			description: $format('description_once', {
				default:
					'Activates the scene once when the condition is met and requires the condition to be repeated for reactivation.',
			}),
			value: 'once',
		},
		{
			title: capFirstChar($format('condition_type_any', { default: 'On any change' })),
			description: $format('description_on_any_change', {
				default:
					'Triggers the scene every time when a monitored value (e.g., temperature or power) changes and meets the pre-set conditions.',
			}),
			value: 'any',
		},
	];
</script>

<Text styleType="h2" class="mb-s">
	{$format('condition_type_title', { default: 'Condition type' })}
</Text>

<Row>
	{#each triggerTypes as trigger}
		<Col md={6} xs={12}>
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				class="width-full"
				variant="radio"
				type="horizontal"
				title={trigger.title}
				descriptiveText={trigger.description}
				selected={trigger.value === sceneData.weatherCondition.execution_type}
				on:click={(e) => {
					sceneData.weatherCondition.execution_type = trigger.value;
				}}
				size="m"
			/>
		</Col>
	{/each}
</Row>
